module.exports = __webpack_public_path__ + "./docs/img/big-icon-prop.607088b94aeaf54d785506c438e3a945.svg";